import { axiosGet } from 'shared/api/axios'

const getAll = async (endpoint: string, showAll: boolean = false) => {
  const requestParams = showAll ? { all: 1 } : {}

  const response = await axiosGet(endpoint, requestParams)

  return response.data
}

export default getAll
